"use strict";
/*---------------------------------------------------------------------------------------------
*  Licensed to the .NET Foundation under one or more agreements.
*  The .NET Foundation licenses this file to you under the MIT license.
*--------------------------------------------------------------------------------------------*/
Object.defineProperty(exports, "__esModule", { value: true });
exports.registerEventStream = registerEventStream;
exports.enableExtensionTelemetry = enableExtensionTelemetry;
const fs = require("fs");
const path = require("path");
const vscode = require("vscode");
const EventStream_1 = require("./EventStream");
const LoggingObserver_1 = require("./LoggingObserver");
const ModalEventPublisher_1 = require("./ModalEventPublisher");
const OutputChannelObserver_1 = require("./OutputChannelObserver");
const StatusBarObserver_1 = require("./StatusBarObserver");
const TelemetryObserver_1 = require("./TelemetryObserver");
function registerEventStream(context, extensionContext, utilityContext, suppressOutput = false) {
    const outputChannel = vscode.window.createOutputChannel(context.displayChannelName);
    if (!fs.existsSync(context.logPath)) {
        fs.mkdirSync(context.logPath, { recursive: true });
    }
    const logFile = path.join(context.logPath, `DotNetAcquisition-${context.extensionId}-${new Date().getTime()}.txt`);
    const loggingObserver = new LoggingObserver_1.LoggingObserver(logFile);
    const eventStreamObservers = [
        new StatusBarObserver_1.StatusBarObserver(vscode.window.createStatusBarItem(vscode.StatusBarAlignment.Left, Number.MIN_VALUE), context.showLogCommand),
        new OutputChannelObserver_1.OutputChannelObserver(outputChannel, suppressOutput),
        loggingObserver
    ];
    const eventStream = new EventStream_1.EventStream();
    for (const observer of eventStreamObservers) {
        eventStream.subscribe(event => observer.post(event));
    }
    let telemetryObserver = null;
    if (context.enableTelemetry) {
        telemetryObserver = new TelemetryObserver_1.TelemetryObserver(context.packageJson, context.enableTelemetry, extensionContext, utilityContext, context.telemetryReporter);
        eventStream.subscribe(event => telemetryObserver.post(event));
    }
    const modalEventObserver = new ModalEventPublisher_1.ModalEventRepublisher(eventStream);
    eventStream.subscribe(event => modalEventObserver.post(event));
    return [eventStream, outputChannel, loggingObserver, eventStreamObservers, telemetryObserver, modalEventObserver];
}
function enableExtensionTelemetry(extensionConfiguration, enableTelemetryKey) {
    const extensionTelemetry = extensionConfiguration.get(enableTelemetryKey);
    const vscodeTelemetry = vscode.workspace.getConfiguration('telemetry').get(enableTelemetryKey);
    const enableDotnetTelemetry = extensionTelemetry === undefined ? true : extensionTelemetry;
    const enableVSCodeTelemetry = vscodeTelemetry === undefined ? true : vscodeTelemetry;
    return enableVSCodeTelemetry && enableDotnetTelemetry;
}
//# sourceMappingURL=EventStreamRegistration.js.map